import { useEffect, useState } from 'react';

// True once the page has finished loading and the browser has a quiet moment.
// For heavy, decorative work (the WebGL scenes) that must not compete with first paint.
export function useWhenIdle(timeout = 1500): boolean {
  const [ready, setReady] = useState(false);

  useEffect(() => {
    let idleId = 0;
    let timer = 0;
    const schedule = () => {
      // Safari has no requestIdleCallback; a short timeout is close enough.
      if (typeof window.requestIdleCallback === 'function') idleId = window.requestIdleCallback(() => setReady(true), { timeout });
      else timer = window.setTimeout(() => setReady(true), 200);
    };
    if (document.readyState === 'complete') schedule();
    else window.addEventListener('load', schedule, { once: true });
    return () => {
      window.removeEventListener('load', schedule);
      if (idleId) window.cancelIdleCallback(idleId);
      window.clearTimeout(timer);
    };
  }, [timeout]);

  return ready;
}

// Visitors on Data Saver (or who ask for reduced data) skip the decorative WebGL scenes.
export function prefersLessData(): boolean {
  const connection = (navigator as Navigator & { connection?: { saveData?: boolean } }).connection;
  return !!connection?.saveData || window.matchMedia('(prefers-reduced-data: reduce)').matches;
}
